import React, { Component } from 'react';
import { Icon } from 'components/antd';
import styles from './NotificationByEmailDisplay.module.scss';

interface Props {
	showTitle?: boolean;
	bookingConfirmation: boolean;
	invoiceConfirmation: boolean;
	calendarBookingEvent: boolean;
}

export default class NotificationByEmailDisplay extends Component<Props> {
	render() {
		const {
			bookingConfirmation,
			invoiceConfirmation,
			calendarBookingEvent,
			showTitle,
		} = this.props;

		return (
			<>
				{showTitle && <h5 className={styles.notificationTitle}>Notification by email:</h5>}
				<ul>
					<li className={styles.notificationList}>
						{bookingConfirmation && <Icon type="apply" />}
						{!bookingConfirmation && <Icon type="remove" />}
						Booking confirmation
					</li>
					<li className={styles.notificationList}>
						{invoiceConfirmation && <Icon type="apply" />}
						{!invoiceConfirmation && <Icon type="remove" />}
						Invoice confirmation
					</li>
					<li className={styles.notificationList}>
						{calendarBookingEvent && <Icon type="apply" />}
						{!calendarBookingEvent && <Icon type="remove" />}
						Calendar booking event
					</li>
				</ul>
			</>
		);
	}
}
